import { BUCKET_MEANING_FA } from './inspect-detail';

export type ChartGuideKey =
  | 'overview-index-status'
  | 'overview-coverage'
  | 'overview-index-requests'
  | 'overview-inspect-activity'
  | 'overview-status-changes'
  | 'overview-settings-checklist'
  | 'advanced-comparison-panel'
  | 'comparison-hero-indexed'
  | 'comparison-hero-excluded'
  | 'comparison-hero-lost'
  | 'comparison-inspect'
  | 'comparison-changes'
  | 'trend-inspect-buckets'
  | 'segment-index-by-path'
  | 'segment-http-by-path'
  | 'index-charts-panel'
  | 'index-daily-activity'
  | 'index-outcome-requests'
  | 'index-outcome-urls'
  | 'inspect-charts-panel'
  | 'inspect-index-status'
  | 'inspect-coverage'
  | 'inspect-noindex'
  | 'inspect-canonical'
  | 'inspect-crawl-freshness'
  | 'inspect-canonical-table'
  | 'inspect-daily-activity'
  | 'inspect-segment-index'
  | 'inspect-segment-http';

export type ChartGuide = {
  matchKey: ChartGuideKey;
  title: string;
  paragraphs: string[];
};

export const CHART_GUIDES: Record<ChartGuideKey, ChartGuide> = {
  'overview-index-status': {
    matchKey: 'overview-index-status',
    title: 'توزیع وضعیت ایندکس',
    paragraphs: [
      BUCKET_MEANING_FA,
      'نشان می‌دهد آدرس‌های شناخته‌شده در پروژه، بر اساس آخرین بازرسی، در کدام bucket هستند: ایندکس‌شده، ایندکس‌نیست، خطا یا هنوز بازرسی نشده.',
      'مثال: اگر ۱۰۰ URL دارید و ۶۰ تا ایندکس‌شده باشند، وسط نمودار حدود ۶۰٪ را می‌بینید.',
    ],
  },
  'overview-coverage': {
    matchKey: 'overview-coverage',
    title: 'جزئیات Coverage',
    paragraphs: [
      'وضعیت دقیق‌تر گوگل برای هر URL را نشان می‌دهد؛ مثل Submitted and indexed یا Crawled — currently not indexed.',
      'مثال: اگر ۲۰ URL در حالت Discovered — not indexed باشند، در جدول همان تعداد را می‌بینید.',
    ],
  },
  'overview-index-requests': {
    matchKey: 'overview-index-requests',
    title: 'درخواست ایندکس',
    paragraphs: [
      'تعداد آدرس‌هایی که در هر روز از Indexing API با موفقیت یا خطا ارسال شده‌اند.',
      'مثال: دوشنبه ۱۵ موفق و ۲ ناموفق یعنی آن روز ۱۷ درخواست ثبت شده است.',
    ],
  },
  'overview-inspect-activity': {
    matchKey: 'overview-inspect-activity',
    title: 'وضعیت ایندکس',
    paragraphs: [
      BUCKET_MEANING_FA,
      'نتیجهٔ بازرسی‌های URL Inspection را روزبه‌روز بر اساس همان bucketها نشان می‌دهد: ایندکس‌شده، ایندکس‌نیست یا خطا.',
      'مثال: اگر چهارشنبه ۳۰ بازرسی انجام دهید، مجموع میله‌های همان روز ۳۰ است.',
    ],
  },
  'overview-status-changes': {
    matchKey: 'overview-status-changes',
    title: 'تغییرات وضعیت',
    paragraphs: [
      BUCKET_MEANING_FA,
      'وقتی بازرسی جدید، bucket وضعیت ایندکس را نسبت به بازرسی قبلی عوض کند اینجا ثبت می‌شود.',
      'مثال: دیروز ایندکس بود و امروز ایندکس‌نیست → در بخش «ایندکس از دست رفت» می‌آید.',
    ],
  },
  'overview-settings-checklist': {
    matchKey: 'overview-settings-checklist',
    title: 'خلاصهٔ تنظیمات',
    paragraphs: [
      'وضعیت آماده‌بودن پروژه را نشان می‌دهد: زمان‌بندی فعال وضعیت ایندکس، زمان‌بندی فعال درخواست ایندکس، اطلاع‌رسانی‌ها (تلگرام/بله) در زمان‌بندی‌های فعال، و آپلود کلید گوگل.',
      'اگر موردی ناقص باشد با لینک «تنظیم» مستقیم به همان صفحه می‌روید.',
    ],
  },
  'advanced-comparison-panel': {
    matchKey: 'advanced-comparison-panel',
    title: 'روند، مقایسه و سگمنت',
    paragraphs: [
      'دورهٔ انتخاب‌شده را با دورهٔ قبلی هم‌اندازه مقایسه می‌کند و روند روزانه و تفکیک مسیر URL را نشان می‌دهد.',
      'مثال: ۷ روز اخیر با ۷ روز قبل از آن؛ اگر ایندکس‌شده‌ها از ۵۰ به ۶۵ برسد، رشد مثبت است.',
    ],
  },
  'comparison-hero-indexed': {
    matchKey: 'comparison-hero-indexed',
    title: 'نتایج ایندکس‌شده',
    paragraphs: [
      'تعداد نتایج بازرسی که در دورهٔ جاری ایندکس‌شده بودند، در مقایسه با دورهٔ قبل.',
      'عدد بیشتر معمولاً بهتر است.',
    ],
  },
  'comparison-hero-excluded': {
    matchKey: 'comparison-hero-excluded',
    title: 'نتایج ایندکس‌نیست',
    paragraphs: [
      'تعداد نتایج بازرسی که در دورهٔ جاری ایندکس نبودند.',
      'عدد کمتر معمولاً بهتر است.',
    ],
  },
  'comparison-hero-lost': {
    matchKey: 'comparison-hero-lost',
    title: 'تغییر: ایندکس از دست رفت',
    paragraphs: [
      'چند URL در این دوره از حالت ایندکس‌شده به ایندکس‌نیست (یا بدتر) تغییر کرده‌اند.',
      'مثال: اگر ۵ باشد یعنی ۵ آدرس نسبت به بازرسی قبلی وضعیت بدتری گرفته‌اند.',
    ],
  },
  'comparison-inspect': {
    matchKey: 'comparison-inspect',
    title: 'مقایسهٔ بازرسی',
    paragraphs: [
      'تعداد نتایج ایندکس‌شده، ایندکس‌نیست و خطا در دورهٔ جاری را با دورهٔ قبلی کنار هم می‌گذارد.',
      'ستون «تغییر» درصد اختلاف را نشان می‌دهد.',
    ],
  },
  'comparison-changes': {
    matchKey: 'comparison-changes',
    title: 'مقایسهٔ تغییرات وضعیت',
    paragraphs: [
      'فقط وقتی بازرسیِ بعدی وضعیت ایندکس یک آدرس را عوض کند اینجا شمرده می‌شود — مثلاً ایندکس شد یا از ایندکس خارج شد.',
      'تعداد این تغییرها در دورهٔ جاری با دورهٔ قبل مقایسه می‌شود؛ جزئیات در صفحهٔ «تغییرات» است.',
    ],
  },
  'trend-inspect-buckets': {
    matchKey: 'trend-inspect-buckets',
    title: 'روند وضعیت ایندکس در بازرسی‌ها',
    paragraphs: [
      BUCKET_MEANING_FA,
      'هر روز چند نتیجهٔ بازرسی در هر bucket (ایندکس‌شده / ایندکس‌نیست / خطا) بوده است.',
      'مثال: میلهٔ بلند سبز یعنی آن روز بازرسی‌های موفق بیشتری ایندکس‌شده گزارش کرده‌اند.',
    ],
  },
  'segment-index-by-path': {
    matchKey: 'segment-index-by-path',
    title: 'وضعیت ایندکس بر اساس مسیر',
    paragraphs: [
      'URLها را بر اساس اولین بخش مسیر (سگمنت) گروه‌بندی می‌کند؛ مثلاً /blog یا /product.',
      'مثال: اگر /blog بیشتر نارنجی باشد، صفحات وبلاگ بیشتر ایندکس نیستند.',
    ],
  },
  'segment-http-by-path': {
    matchKey: 'segment-http-by-path',
    title: 'کدهای HTTP بر اساس مسیر',
    paragraphs: [
      'کد وضعیت HTTP آخرین بازرسی هر URL را در هر سگمنت مسیر نشان می‌دهد.',
      'مثال: نوار قرمز در /old یعنی آدرس‌های آن مسیر اغلب ۴۰۴ یا ۵۰۰ دارند.',
    ],
  },
  'index-charts-panel': {
    matchKey: 'index-charts-panel',
    title: 'نمودارهای درخواست ایندکس',
    paragraphs: [
      'خلاصهٔ فعالیت ارسال به Google Indexing API در همان بازهٔ زمانی کارت‌های آمار بالای صفحه.',
    ],
  },
  'index-daily-activity': {
    matchKey: 'index-daily-activity',
    title: 'درخواست ایندکس',
    paragraphs: [
      'تعداد آدرس‌هایی که در هر روز از Indexing API با موفقیت یا خطا ارسال شده‌اند.',
      'مثال: دوشنبه ۱۵ موفق و ۲ ناموفق یعنی آن روز ۱۷ درخواست ثبت شده است.',
    ],
  },
  'index-outcome-requests': {
    matchKey: 'index-outcome-requests',
    title: 'نتیجهٔ درخواست‌ها',
    paragraphs: [
      'هر جاب ارسال (یک بار کلیک «ارسال») یک واحد شمارش می‌شود؛ موفق یا ناموفق.',
      'مثال: ۳ جاب با ۵۰ URL → ۳ بخش در نمودار، نه ۱۵۰.',
    ],
  },
  'index-outcome-urls': {
    matchKey: 'index-outcome-urls',
    title: 'نتیجهٔ آدرس‌ها',
    paragraphs: [
      'همهٔ URLهای داخل جاب‌ها جمع می‌شوند؛ مناسب وقتی می‌خواهید حجم واقعی آدرس را ببینید.',
      'مثال: ۳ جاب با ۵۰+۳۰+۲۰ URL → ۱۰۰ آدرس در نمودار.',
    ],
  },
  'inspect-charts-panel': {
    matchKey: 'inspect-charts-panel',
    title: 'نمودارهای وضعیت ایندکس',
    paragraphs: [
      'وضعیت فعلی کاتالوگ URL بر اساس آخرین بازرسی هر آدرس، به‌اضافهٔ فعالیت بازرسی در بازهٔ انتخاب‌شده.',
    ],
  },
  'inspect-index-status': {
    matchKey: 'inspect-index-status',
    title: 'وضعیت ایندکس',
    paragraphs: [
      BUCKET_MEANING_FA,
      'توزیع کلی bucket هر URL در پروژه: ایندکس‌شده، ایندکس‌نیست، خطا یا بدون بازرسی.',
      'همان منطق نمودار نمای کلی است، ولی فقط برای صفحهٔ بازرسی.',
    ],
  },
  'inspect-coverage': {
    matchKey: 'inspect-coverage',
    title: 'جزئیات Coverage',
    paragraphs: [
      'وضعیت رسمی coverage گوگل برای هر URL؛ برای فهمیدن دلیل ایندکس نبودن مفید است.',
      'روی هر ردیف می‌توانید راهنمای همان وضعیت را ببینید.',
    ],
  },
  'inspect-noindex': {
    matchKey: 'inspect-noindex',
    title: 'وضعیت Noindex',
    paragraphs: [
      'فقط بین URLهایی که حداقل یک‌بار بازرسی شده‌اند: آیا تگ noindex دارند یا اجازهٔ ایندکس؟',
      'مثال: ۱۰٪ noindex یعنی یک‌دهم صفحات بازرسی‌شده عمداً از ایندکس خارج شده‌اند.',
    ],
  },
  'inspect-canonical': {
    matchKey: 'inspect-canonical',
    title: 'وضعیت Canonical',
    paragraphs: [
      'نشان می‌دهد URL خودش کانونیکال است، به جای دیگری اشاره می‌کند یا کانونیکال ندارد.',
      'مثال: اگر بخش زیادی Alternate باشد، ممکن است نسخهٔ دیگری ایندکس شود.',
    ],
  },
  'inspect-crawl-freshness': {
    matchKey: 'inspect-crawl-freshness',
    title: 'تازگی کرول',
    paragraphs: [
      'بر اساس lastCrawlTime گوگل: تازه (کمتر از آستانهٔ بک‌اند)، کهنه یا هرگز کرول نشده. برچسب خزش قدیمی از فیلد APIی staleCrawl می‌آید.',
      'صفحهٔ کهنه لزوماً ایندکس نیست، ولی ممکن است به‌روزرسانی نیاز داشته باشد.',
    ],
  },
  'inspect-canonical-table': {
    matchKey: 'inspect-canonical-table',
    title: 'جدول Canonical',
    paragraphs: [
      'همان دادهٔ نمودار Canonical به‌صورت جدول با تعداد و درصد هر حالت.',
      'برای مقایسهٔ دقیق اعداد راحت‌تر از نمودار است.',
    ],
  },
  'inspect-daily-activity': {
    matchKey: 'inspect-daily-activity',
    title: 'وضعیت ایندکس',
    paragraphs: [
      BUCKET_MEANING_FA,
      'نتیجهٔ بازرسی‌های URL Inspection را روزبه‌روز بر اساس همان bucketها نشان می‌دهد: ایندکس‌شده، ایندکس‌نیست یا خطا.',
      'مثال: اگر چهارشنبه ۳۰ بازرسی انجام دهید، مجموع میله‌های همان روز ۳۰ است.',
    ],
  },
  'inspect-segment-index': {
    matchKey: 'inspect-segment-index',
    title: 'وضعیت بر اساس مسیر',
    paragraphs: [
      'وضعیت ایندکس را برای هر بخش از سایت (اولین سگمنت URL) جدا می‌کند.',
      'مثال: /shop سبز و /blog نارنجی → اولویت بهبود روی وبلاگ است.',
    ],
  },
  'inspect-segment-http': {
    matchKey: 'inspect-segment-http',
    title: 'HTTP بر اساس مسیر',
    paragraphs: [
      'کد HTTP آخرین بازرسی را در هر سگمنت مسیر نشان می‌دهد.',
      'برای پیدا کردن مسیرهایی با خطای ۴۰۴ یا ۵۰۰ مفید است.',
    ],
  },
};

export function getChartGuide(key: ChartGuideKey): ChartGuide {
  return CHART_GUIDES[key];
}
